import React from 'react';
import PropTypes from 'prop-types';
import rpCookie from 'rp-cookie';
import classNames from 'classnames';
import styles from './LogoutButton.scss';

const handleLogout = () => {
  const userIdCookie = rpCookie.sharedPermanent.get('rp_uid');
  const lastLoggedDateWeb = rpCookie.sharedSession.get('rp_last_logged_in_date_web');

  localStorage.setItem('recentLogoutData', JSON.stringify({
    isLoggedOut: true,
    userId: JSON.parse(userIdCookie) || '',
    lastLoggedDateWeb: lastLoggedDateWeb || '',
  }));
  window.authApi.logout();
};

function LogoutButton({ className }) {
  return (
    <button
      type="button"
      className={classNames(styles.logout, className)}
      onClick={handleLogout}
    >
      Log out
    </button>
  );
}

LogoutButton.propTypes = {
  className: PropTypes.string,
};

LogoutButton.defaultProps = {
  className: '',
};

export default LogoutButton;
